import { render, staticRenderFns } from "./PageList.vue?vue&type=template&id=1899a3d4&scoped=true&"
import script from "./PageList.vue?vue&type=script&lang=js&"
export * from "./PageList.vue?vue&type=script&lang=js&"
import style0 from "./PageList.vue?vue&type=style&index=0&id=1899a3d4&prod&scoped=true&lang=css&"
import style1 from "./PageList.vue?vue&type=style&index=1&id=1899a3d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1899a3d4",
  null
  
)

export default component.exports